<template>
  <div class="principal-body">
    <div style="background-color: white; display: flex;align-items: center;">
      <v-icon style="margin-right: 5px" @click="goBack">
        mdi-chevron-left
      </v-icon>
      <Avatar :address="invoices[0]._id" style="margin-top: 2%; margin-right: 5px" />
      <span> <strong> {{ $t('AllInvoicesChat.headGroup') }} </strong> </span>
    </div>
    <div v-for="invoice in invoices" :key="invoice._id" style="overflow-x: hidden; overflow-y: auto">
      <ItemListInvoice :invoice="invoice" :payer="true" :chat="idChat" />
      <v-divider class="borderDividerArchived" />
    </div>
  </div>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";
import Avatar from "./Avatar";
import ItemListInvoice from "components/ItemListInvoice";

export default {
    name: "AllInvoicesChat",
    components: {Avatar, ItemListInvoice},
    data () {
        return {
            idChat: "",
            chatInformation: null,
            invoices: [],
            image: null,

        };
    },
    created () {
        const url = this.getAllUrlParams(window.location.href);
        if (url.chatid !== undefined) {
            this.idChat = url.chatid;
        }
    },
    mounted () {
        this.fetch();
    },
    methods: {
        async fetch () {
            await ApiRepository.getChat(this.idChat).then((res) => {
                this.chatInformation = res.data.chat;
                this.invoices.push(this.chatInformation.invoice);
                if (this.chatInformation.newInvoice) this.invoices.push(this.chatInformation.newInvoice);
                if (this.chatInformation.rectifyingInvoice) this.invoices.push(this.chatInformation.rectifyingInvoice);
            });

        },
        getAllUrlParams (url) {
        // get query string from url (optional) or window
            let queryString = url ? url.split('?')[1] : window.location.search.slice(1);

            // we'll store the parameters here
            const obj = {};

            // if query string exists
            if (queryString) {

                // stuff after # is not part of query string, so get rid of it
                queryString = queryString.split('#')[0];

                // split our query string into its component parts
                const arr = queryString.split('&');

                for (const element of arr) {
                    // separate the keys and the values
                    const a = element.split('=');

                    // set parameter name and value (use 'true' if empty)
                    let paramName = a[0];
                    let paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

                    // (optional) keep case consistent
                    paramName = paramName.toLowerCase();
                    if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

                    // if the paramName ends with square brackets, e.g. colors[] or colors[2]
                    if (paramName.match(/\[(\d+)?\]$/)) {

                        // create key if it doesn't exist
                        const key = paramName.replace(/\[(\d+)?\]/, '');
                        if (!obj[key]) obj[key] = [];

                        // if it's an indexed array e.g. colors[2]
                        if (paramName.match(/\[\d+\]$/)) {
                            // get the index value and add the entry at the appropriate position
                            const index = /\[(\d+)\]/.exec(paramName)[1];
                            obj[key][index] = paramValue;
                        } else {
                            // otherwise add the value to the end of the array
                            obj[key].push(paramValue);
                        }
                    } else if (!obj[paramName]) {
                        // if it doesn't exist, create property
                        obj[paramName] = paramValue;
                    } else if (obj[paramName] && typeof obj[paramName] === 'string') {
                        // if property does exist and it's a string, convert it to an array
                        obj[paramName] = [obj[paramName]];
                        obj[paramName].push(paramValue);
                    } else {
                        // otherwise add the property
                        obj[paramName].push(paramValue);
                    }

                }
            }
            return obj;
        },
        goBack () {
            this.$router.push({name: 'Chat', query: {chatId: this.idChat}, replace: true});
        },
    }
};
</script>

<style scoped>
img {
  aspect-ratio: 4/3;
  width:100%;
  object-fit: cover;
}
</style>
